import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from "dayjs";
export default {
  filters: {
    grain: function grain(type) {
      var res = "";
      switch (type) {
        case "day":
          res = "天";
          break;
        case "week":
          res = "周";
          break;
        case "month":
          res = "月";
          break;
        case "week":
          res = "周";
          break;
        case "quarter":
          res = "季";
          break;
        case "year":
          res = "年";
          break;
        default:
          break;
      }
      return res;
    }
  },
  data: function data() {
    return {
      communityGrain: "day",
      dateTime: [dayjs().subtract(1, "month").format("YYYY-MM-DD"), dayjs().subtract(0, "day").format("YYYY-MM-DD")],
      loading: false,
      lineChart: null,
      chart: null,
      legendSelected: {},
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      }
    };
  },
  methods: {
    getChartInstance: function getChartInstance(instance) {
      return instance || this.chart || this.lineChart;
    },
    bindLegendSync: function bindLegendSync(instance) {
      var _this = this;
      var chart = this.getChartInstance(instance);
      if (!chart || !chart.chart) return;
      this.syncLegendSelectionFromChart(chart);
      chart.on('legend-item:click', function () {
        setTimeout(function () {
          return _this.syncLegendSelectionFromChart(chart);
        }, 0);
      });
    },
    syncLegendSelectionFromChart: function syncLegendSelectionFromChart(instance) {
      var _ref;
      var chart = this.getChartInstance(instance);
      if (!chart || !chart.chart) return;
      var comps = chart.chart.getComponents().filter(function (c) {
        return c.type === 'legend';
      });
      var items = (_ref = []).concat.apply(_ref, _toConsumableArray(comps.map(function (c) {
        return c.component.getItems ? c.component.getItems() : [];
      })));
      var selected = {};
      items.forEach(function (it) {
        var name = it.name || it.value;
        if (name) selected[name] = !it.unchecked;
      });
      this.legendSelected = selected;
    },
    restoreLegendSelection: function restoreLegendSelection(instance) {
      var chart = this.getChartInstance(instance);
      if (!chart) return;
      if (typeof chart.update === 'function') {
        chart.update({
          legend: {
            selected: this.legendSelected
          }
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.lineChart && typeof this.lineChart.destroy === 'function') {
      this.lineChart.destroy();
      this.lineChart = null;
    }
    if (this.chart && typeof this.chart.destroy === 'function') {
      this.chart.destroy();
      this.chart = null;
    }
  }
};